import React from "react";
import styles from "./ProjectDeletionModal.module.scss";
import toast from "components/Toast/toast";
import { API } from "../../service/Interceptor";
import { useNavigate } from "react-router-dom";
import { ReactComponent as DeleteProjectImg } from "../../images/SVG/DeleteProjectImg.svg";
import Modal from "components/Modal/Modal";
import Button from "components/UI/Button/Button";

const ProjectDeletionModal = ({ id, projectDeleted, setProjectDeleted }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropogation();
  };
  const navigate = useNavigate();
  const handleDeleteProject = async (id) => {
    try {
      const res = await API.delete(`api/jobs/${id}`);
      if (res?.data?.success) {
        toast.success("Project Disabled");
        setProjectDeleted(false);
        setTimeout(() => {
          navigate("/projects");
        }, 2000);
      }
    } catch (error) {
      setProjectDeleted(false);
      console.log(error);
    }
  };
  return (
    <Modal
      onClose={() => {
        setProjectDeleted(false);
        navigate("/projects");
      }}
      modalOpen={projectDeleted}
    >
      <div className={styles.mainDiv}>
        <div className={styles.leftDiv}>
          <DeleteProjectImg />
        </div>
        <div className={styles.rightDiv}>
          <div className={styles.content}>
            <h1>Disable</h1>
            <p>Are you sure?</p>
            <p>you want to disable this project</p>
          </div>
          <div className={styles.button}>
            <Button
              variant="outlined"
              onClick={() => setProjectDeleted(false)}
            >
              Cancel
            </Button>
            <Button
              variant="filled"
              onClick={() => handleDeleteProject(id)}
            >
              Disable
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ProjectDeletionModal;
